export const CURRENT_GROUP_UUID = 'current-group-uuid'
